import { createThunk } from '../services/create-thunk';
import { parseAppSettings } from '../services/parse-app-settings';

export const FETCH_APP_SETTINGS_REQUEST = 'appSettings/FETCH_REQUEST';
export const FETCH_APP_SETTINGS_SUCCESS = 'appSettings/FETCH_SUCCESS';
export const FETCH_APP_SETTINGS_FAILURE = 'appSettings/FETCH_FAILURE';
export const WAIT_FOR_APP_SETTINGS = 'appSettings/WAIT_FOR';

export const fetchAppSettingsRequest = () => ({
  type: FETCH_APP_SETTINGS_REQUEST,
});
export const fetchAppSettingsSuccess = (payload) => ({
  type: FETCH_APP_SETTINGS_SUCCESS,
  payload,
});
export const fetchAppSettingsFailure = () => ({
  type: FETCH_APP_SETTINGS_FAILURE,
});
export const waitForAppSettings = (action, invokeBeforeDispatch) => (dispatch) =>
  new Promise((resolve) =>
    dispatch({
      type: WAIT_FOR_APP_SETTINGS,
      payload: { action, resolve, invokeBeforeDispatch },
    }),
  );

export function fetchAppSettings(params) {
  return createThunk((dispatch, getState, { request }) => {
    dispatch(fetchAppSettingsRequest());
    const { compId, viewMode, externalId } = parseAppSettings(params, getState());
    const promise = request(`/_api/settings?compId=${compId}&externalId=${externalId}&viewMode=${viewMode}`);

    return promise
      .then((settings) => dispatch(fetchAppSettingsSuccess(settings)))
      .catch(() => dispatch(fetchAppSettingsFailure()))
      .then(() => promise);
  });
}

export function fetchPageAppSettings(search) {
  return createThunk((dispatch, getState, { request }) => {
    dispatch(fetchAppSettingsRequest());

    const { viewMode } = parseAppSettings(search, getState());
    const promise = request(`/_api/settings/page?viewMode=${viewMode}`);
    return promise
      .then((settings) => dispatch(fetchAppSettingsSuccess(settings)))
      .catch(() => dispatch(fetchAppSettingsFailure()))
      .then(() => promise);
  });
}
